<template>
	<div>
		<el-card>
			<el-form :model="form" ref="userform" :inline="true">
				<el-form-item label="调整编号:">
					<el-input placeholder="请输入调整编号" v-model="form.orderid" style="width: 350px;"></el-input>
				</el-form-item>
				<el-form-item label="账号:">
					<el-input placeholder="请输入查询账号" v-model="form.username" style="width: 350px;"></el-input>
				</el-form-item>
				<el-form-item label="调整日期:">
					<el-date-picker v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm()">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button  @click="resetForm()">重置</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="order_num" label="订单编号" >
				</el-table-column>
				<el-table-column prop="payuserinfo.name" label="付款人姓名" >
				</el-table-column>
				<el-table-column prop="payuserinfo.id" label="付款人ID" >
				</el-table-column>
				<el-table-column prop="payuserinfo.nickname" label="付款人昵称" >
				</el-table-column>
				<el-table-column prop="payeeuserinfo.name" label="收款人姓名">
				</el-table-column>
				<el-table-column prop="payeeuserinfo.id" label="收款人ID" >
				</el-table-column>
				<el-table-column prop="payeeuserinfo.nickname" label="收款人昵称" >
				</el-table-column>
				<el-table-column prop="price" label="订单图力值" >
				</el-table-column>
				<el-table-column prop="remark" label="订单属性" >
				</el-table-column>
				<el-table-column prop="parent_order_num" label="主订单号" >
				</el-table-column>
				<el-table-column prop="option_admin" label="状态">
					
					<template slot-scope="scope">
						<div >
							{{scope.row.state == '1'? "成功":scope.row.state == '0'?'进行中':'已拒绝'}}
						</div>
						
					</template>
				</el-table-column>
				<el-table-column prop="start_time" label="创建时间">
				</el-table-column>
			</el-table>
			<Pageing :page="page" :size="size" :total="total" @current-change="handleChangePage"></Pageing>
		</el-card>
	</div>
</template>

<script>
	import Pageing from '../../components/page/page.vue'
	import {
		getmoneyorderList
	} from '../../api/recharge.js'
	export default {
		components: {
			Pageing
		},
		data() {
			return {
				formLabelWidth: '120px',
				
				page:1,
				size:10,
				total:0,
				tableData: [],
				runmoney:0,
				checkAll: false,
				form: {
					orderid: '',
					time: '',
					username:''
				},
				
				forminfo:{},
			};
		},
		mounted() {
			this.getuserlist()
		},
		methods: {
			getuserlist(){
				getmoneyorderList({
					page:this.page,
					order_num:this.form.orderid,
					start_time:this.form.time,
					username:this.form.username
				}).then(res=>{
					this.tableData = res.list
					this.total = res.total 
					
				})
				
			},
			
			submitForm() {
				this.getuserlist()
			},
			handleChangePage(val){
				this.page = val
				this.getuserlist()
			},
			resetForm(){
				//this.$refs.userform.resetFields()
				this.form.orderid = ''
				
				this.form.username = ''
				
				this.form.time = ''
				this.getuserlist()
			}
			
		}
	};
</script>

<style lang="less" scoped>
	.runmoney{
		display: flex; 
		flex-direction: column;
		align-items: center;
		ul{
			display: flex;
			li{
				text-align: center;
				margin: 0 20px;
			}
		}
	}
	
</style>
